import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/reducers/store';
import { Box, CircularProgress, ITheme, IconButton, Modal, Typography, useTheme } from '@mui/material';
import FundDetailsTabs from './FundDetailsTabs';
import FundDetailsTabContent from './FundDetailsTabContent';
import CloseIcon from '@mui/icons-material/Close';
import { loadListOfFunds, setSelectedFund } from '../../store/actions/libraryOfFunds';

export interface IFundDetailsProps {
    pageRange?: number[];
    showPopin?: boolean;
    createPortfolio?: boolean;
    displayItem?: number;
    onClose?: () => void;
}
const FundDetails: React.FC<IFundDetailsProps> = ({ pageRange, showPopin, createPortfolio, displayItem, onClose }) => {
    const selectedFundId = useAppSelector(state => state.libraryOfFundsReducer.selectedFund);
    const funds = useAppSelector(state => state.libraryOfFundsReducer.funds);
    const showMore = useAppSelector(state => state.libraryOfFundsReducer.showMore);
    const dispatch = useAppDispatch();
    const theme = useTheme() as ITheme;
    const [selectedTab, setSelectedTab] = useState(0);

    const selectedFund = (funds !== undefined && selectedFundId !== undefined ?
        funds.filter(f => f.id === selectedFundId)
        : (funds !== undefined && displayItem !== undefined ? funds.filter(f => f.id === displayItem) :undefined));

    useEffect(() => {
        setSelectedTab(0);
    }, [selectedFundId]);

    useEffect(() => {
        if (funds === undefined) {
            dispatch(loadListOfFunds());
        }
    }, [])

    const onCloseClick = () => {
        if (onClose !== undefined){
            onClose()
        }else{
        dispatch(setSelectedFund(selectedFundId));
        }
    }

    let content = <></>;

    if (displayItem !== undefined) {
        if (selectedFund === undefined || selectedFund.length === 0 ) {
            content = <CircularProgress />
        } else {
            content = <Box display="flex" flexDirection={"column"} width={"100%"} gap={"32px"}>
                {!showPopin && <Box position={"relative"} marginTop={"-70px"} display={"flex"} justifyContent={"flex-end"}>
                    <IconButton size='medium' onClick={onCloseClick}>
                        <CloseIcon fontSize='medium' />
                    </IconButton>
                </Box>}
                <FundDetailsTabs selectedTab={selectedTab} onTabClick={(index: number) => setSelectedTab(index)} />
                <FundDetailsTabContent fund={selectedFund[0]} page={selectedTab} createPortfolio={createPortfolio} />
            </Box>
        }
    } else if (selectedFundId == undefined || selectedFund === undefined || selectedFund.length === 0 || pageRange === undefined || pageRange.indexOf(selectedFundId) === -1) {
        return <></>
    } else {
        content = <Box display="flex" flexDirection={"column"} width={"100%"} gap={"32px"}>
            {!createPortfolio && <Box position={"relative"} marginTop={"-70px"} display={"flex"} justifyContent={"flex-end"}>
                <IconButton size='medium' onClick={onCloseClick}>
                    <CloseIcon fontSize='medium' />
                </IconButton>
            </Box>}
            <FundDetailsTabs selectedTab={selectedTab} onTabClick={(index: number) => setSelectedTab(index)} />
            <FundDetailsTabContent fund={selectedFund[0]} page={selectedTab} createPortfolio={createPortfolio} />
        </Box>
    }



    if (showPopin) {
        return <Modal
            open={showMore || displayItem !== undefined}
            onClose={onCloseClick}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box width={"1433px"} bgcolor={"#F2F5FA"} padding={"38px 39px"} borderRadius={"8px"} sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                    <Typography fontSize={"24px"} lineHeight={"29.26px"} fontWeight={"700"}>Fund Details</Typography>
                    <IconButton onClick={onCloseClick}>
                        <CloseIcon sx={{ color: theme.palette.primary.dark }} />
                    </IconButton>
                </Box>
                {content}
            </Box>
        </Modal>
    }
    return content
}

export default FundDetails;